module.exports = __webpack_public_path__ + "static/media/bettr-create-tasks-dark.71b928d6.png";